module.exports = "<th>Телефонных линий минимум</th>\n<td>\n  <div class=\"advanced-browser__item\">\n    <input type=\"number\" class=\"s-input s-input_length_xs\" ng-model=\"source.phone_lines_count.value.gte\">\n  </div>\n\n  <term\n    source=\"source.add_phones\"\n    behavior=\"checkbox\"\n    text=\"С возможностью увеличения\"/>\n</td>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/advanced-browser/templates/sections/phone_lines.html
// module id = 353
// module chunks = 0